import { asCurrency } from '@ally/aos-utils';
import { isExternal } from '@ally/transfer-account-utils';
import { validator } from '@ally/validator';
import { DEFAULT_NEW_CUSTOMER_LIMIT } from '../../../constants';
var DoesNotExceedNewCustomerLimit = function (amount, _a) {
    var disableNewCustomerLimit = _a.disableNewCustomerLimit, isNewCustomer = _a.isNewCustomer, toAccount = _a.toAccount, _b = _a.newCustomerLimit, newCustomerLimit = _b === void 0 ? DEFAULT_NEW_CUSTOMER_LIMIT : _b;
    // If FF is disabled, skip validation
    if (disableNewCustomerLimit)
        return true;
    // If user is not a new customer, skip validation
    if (!isNewCustomer)
        return true;
    // Validation only applies to outgoing external transfers
    if (!toAccount || !isExternal(toAccount))
        return true;
    // Amount must be LTE limit
    return amount <= newCustomerLimit;
};
export var DoesNotExceedNewCustomerLimitErrorMessage = function (_, _a) {
    var _b = _a.newCustomerLimit, newCustomerLimit = _b === void 0 ? DEFAULT_NEW_CUSTOMER_LIMIT : _b;
    return "There\u2019s a ".concat(asCurrency(newCustomerLimit), " limit on transfers to accounts at other institutions until you\u2019ve been with us over 90 days.");
};
export var DoesNotExceedNewCustomerLimitValidator = validator(DoesNotExceedNewCustomerLimit, DoesNotExceedNewCustomerLimitErrorMessage);
//# sourceMappingURL=DoesNotExceedNewCustomerLimit.js.map